import React from "react";
import logo from "./img/logo.png";

export default function Footer() {
  return (
    <div>
      <footer>
        <div className="container">
          <div class="big_row">
            <div className="title">
              <img src={logo} alt="" />
              <span>Estate</span>
            </div>

            <p>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit
              consectetur.
            </p>
          </div>
          <div class="row">
            <h4>Company</h4>
            <div class="links">
              <a href="">Home</a>
              <a href="">About us</a>
              <a href="">Contact us</a>
              <a href="">Privacy policy</a>
            </div>
          </div>
          <div class="row">
            <h4>Subscribe to our newsletter</h4>
            <p>
              The latest news, articles, and resources, sent to your inbox
              weekly.
            </p>
            <form action="">
              <input type="text" placeholder="Your Email" />
              <button>Subscribe</button>
            </form>
          </div>
        </div>
      </footer>
    </div>
  );
}
